/** Timeline, cost and language text for a pathway record. */
export function pathwayTimeline(p) {
  const v = Number(p && p.timeframe_value)
  const to = Number(p && p.timeframe_value_to)
  const u = String((p && p.timeframe_unit) || '')
  if (!v || !u) return ''
  const unit = (n) => {
    if (/month/i.test(u) && n % 12 === 0) { const y = n / 12; return y === 1 ? '1 year' : `${y} years` }
    return `${n} ${u}`
  }
  if (to && to > v) {
    // "12 to 18 months", or "1 to 2 years" when both land on whole years
    if (/month/i.test(u) && v % 12 === 0 && to % 12 === 0) return `${v / 12} to ${to / 12} years`
    return `${v} to ${to} ${u}`
  }
  return unit(v)
}

export function pathwayCost(p) {
  const a = Number(p && p.cost_from)
  const b = Number(p && p.cost_to)
  const money = (n) => `$${Math.round(n).toLocaleString('en-US')}`
  if (!a && !b) return ''
  if (a && b && b > a) return `${money(a)} to ${money(b)}`
  return `From ${money(a || b)}`
}

// Language support is hidden on the site for now (Corey, 2026-10-28). Flip this to show the
// "Spanish support" badge on cards and the "Support in Spanish" line on path pages again.
export const SHOW_PATH_LANGUAGES = false

export function pathwayLanguages(p) {
  if (!SHOW_PATH_LANGUAGES) return []
  const labels = (p && p.language_labels) || []
  return Array.isArray(labels) ? labels.filter(Boolean) : []
}

/** The language's own name, the way a speaker would look for it. Keyed by the stored code. */
const NATIVE = {
  es: 'Español', zh: '中文', tl: 'Tagalog', vi: 'Tiếng Việt', ar: 'العربية', fr: 'Français', ko: '한국어', ru: 'Русский',
  pt: 'Português', ht: 'Kreyòl ayisyen', hi: 'हिन्दी', de: 'Deutsch', pl: 'Polski', it: 'Italiano', ur: 'اردو', ja: '日本語',
  fa: 'فارسی', gu: 'ગુજરાતી', te: 'తెలుగు', bn: 'বাংলা', ta: 'தமிழ்', pa: 'ਪੰਜਾਬੀ', am: 'አማርኛ', so: 'Soomaali', hmn: 'Hmoob'
}
export function pathwayLanguageNative(p) {
  const code = (p && Array.isArray(p.languages) && p.languages[0]) || ''
  if (!code) return ''
  return NATIVE[code] || pathwayLanguages(p)[0] || ''
}
